import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import OutsideClickHandler from 'react-outside-click-handler';

import { Wrap, Trigger, Menu, Item } from './lang-selector.v2.styled';

const LANGS = [
  { code: 'ru', label: 'RU', native: 'Русский' },
  { code: 'kk', label: 'KZ', native: 'Қазақша' },
  { code: 'ar', label: 'AR', native: 'العربية' },
  { code: 'en', label: 'EN', native: 'English' },
];

const GlobeIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden>
    <circle cx="12" cy="12" r="9" />
    <path d="M3 12h18M12 3c2.5 2.5 3.8 5.7 3.8 9s-1.3 6.5-3.8 9c-2.5-2.5-3.8-5.7-3.8-9S9.5 5.5 12 3z" />
  </svg>
);

const CaretIcon = () => (
  <svg className="caret" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" aria-hidden>
    <path d="M6 9l6 6 6-6" />
  </svg>
);

/**
 * Compact language dropdown for the v2 redesign — a single pill (globe + code)
 * that opens a menu of languages with their native names.
 *
 * @param {boolean} onDark  style for a dark surface (login card footer).
 * @param {boolean} dropUp  open the menu upwards (use near a bottom edge).
 */
export const LangSelectorV2 = ({ onDark = false, dropUp = false }) => {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);

  const current = LANGS.find((l) => l.code === i18n.language) || LANGS[0];

  const changeLang = (code) => {
    i18n.changeLanguage(code);
    localStorage.setItem('lang', code);
    setOpen(false);
  };

  return (
    <OutsideClickHandler onOutsideClick={() => setOpen(false)}>
      <Wrap>
        <Trigger type="button" $onDark={onDark} aria-expanded={open} aria-label="Выбор языка" onClick={() => setOpen((v) => !v)}>
          <GlobeIcon />
          {current.label}
          <CaretIcon />
        </Trigger>
        {open && (
          <Menu $dropUp={dropUp} role="listbox">
            {LANGS.map((l) => (
              <Item key={l.code} type="button" role="option" aria-selected={l.code === current.code} $active={l.code === current.code} onClick={() => changeLang(l.code)}>
                <span className="native">{l.native}</span>
                <span className="code">{l.label}</span>
              </Item>
            ))}
          </Menu>
        )}
      </Wrap>
    </OutsideClickHandler>
  );
};
